import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: 'Edit personal data',
  saveAndNext: 'Save & Next',
  originalText: 'Response',
  editedText: 'Edited response',
  detectedLanguage: 'Auto-detected language',
  languageRequiredForRememberedWords: 'Select a language before saving words to the whitelist or blacklist.',
});
